
/*************************
 * instead of prodId, variant ID can also be passed
 *
**************************/


function addProductToCart(prodId, quantity) {
    let formData = {
      'items': [
        {
       'id': prodId,
       'quantity': quantity
       }
      ]
     };
     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => {
       return response.json();
     })
     .catch((error) => {
       console.error('Error:', error);
     });
  }
  
  function addProductListToCart(prodList) {
     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(prodList)
     })
     .then(response => {
       return response.json();
     })
     .catch((error) => {
       console.error('Error:', error);
     });
  }
  
  